import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useEffect, useState } from 'react'
import { AuthFetchError } from '@e3dc-react/shell/Types/api'
import { VehicleInformationModel } from '../models'
import { fetchTargetSoc } from '../api'
import { TargetSocDto } from '../dto'

interface UseTargetSoc {
  targetSoc: TargetSocDto['targetSoC']
  changeTargetSoc: (targetSoc: TargetSocDto['targetSoC']) => void
  loading: boolean
  error?: Error | AuthFetchError
  hasError: boolean
}

/**
 * Hook for handling fetching of vehicle targetSoC
 */
export const useTargetSoc = (vehicleId: VehicleInformationModel['id'], installationId: number): UseTargetSoc => {
  const [targetSoc, setTargetSoc] = useState<TargetSocDto['targetSoC']>(0)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | AuthFetchError | undefined>(undefined)
  const [hasError, setHasError] = useState(false)
  const authFetch = useAuthFetchWithResponse()

  const changeTargetSoc = (targetSoC: TargetSocDto['targetSoC']): void => {
    setTargetSoc(targetSoC)
  }

  useEffect(() => {
    const getTargetSoc = async (): Promise<void> => {
      setHasError(false)
      setError(undefined)
      setLoading(true)
      const { error, hasErrors, value } = await fetchTargetSoc(vehicleId, installationId, authFetch)
      setLoading(false)

      if (hasErrors) {
        setHasError(hasErrors)
        if (error) setError(error)
      }
      if (value) {
        setTargetSoc(value.targetSoC)
      }
    }

    getTargetSoc()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleId])

  return { targetSoc, changeTargetSoc, loading, error, hasError }
}
